import { createContext, useContext } from "react";
import { ZodSchema } from "zod";

import { PyFormApi } from "./types";

// Context for our form
export const PyFormContext = createContext<PyFormApi<ZodSchema, Record<string, unknown>> | null>(null);

export const usePyForm = <
	TSchema extends ZodSchema,
	TOnSubmitMeta extends Record<string, unknown> = Record<string, unknown>,
>() => {
	const context = { ...useContext(PyFormContext) };
	if (!context) {
		throw new Error(
			"Form Fields must be used within a Form component, which provides the proper Form context. Use the PYForm component to wrap your form."
		);
	}
	return context as PyFormApi<TSchema, TOnSubmitMeta> & { id: string; schema: TSchema; onSubmitMeta: TOnSubmitMeta };
};
